// A Mystic nobody has visited for a while has no drop made for today: the BE
// queues it on this visit (reader_detail -> drop_pending: true) and it lands a
// minute or few later. Check back until it does, then hand it over.
//
// fetchDetail() resolves to the reader_detail payload. Returns a stop() function.
export function waitForTodayDrop({ fetchDetail, today, onDrop, onGiveUp,
                                   everyMs = 15000, forMs = 10 * 60 * 1000 }) {
  let stopped = false
  let timer = null
  const deadline = Date.now() + forMs

  const tick = async () => {
    if (stopped) return
    try {
      const data = await fetchDetail()
      const drop = data?.today_drop
      if (drop && drop.drop_date === today) {
        stopped = true
        onDrop(drop)
        return
      }
      if (data && data.drop_pending === false) {
        // Nothing is being made any more (it failed): stop the loader.
        stopped = true
        onGiveUp?.()
        return
      }
    } catch (e) {
      // A failed check is not the end: try again next tick.
    }
    if (Date.now() >= deadline) {
      stopped = true
      onGiveUp?.()
      return
    }
    timer = setTimeout(tick, everyMs)
  }
  timer = setTimeout(tick, everyMs)
  return () => { stopped = true; clearTimeout(timer) }
}
